import { lazy } from 'react';

const EditBonuses = lazy(() => import('./edit'));
const CreateBonuses = lazy(() => import('./create'));

export { EditBonuses, CreateBonuses };
